import React from "react";
import { Dialog, Slide, Backdrop, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddBankAccountForm from "layouts/bankAccounts/components/newBankAccount";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AddBankAccountModal = ({ open, onClose, onUserAdded, initialData }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
      PaperProps={{
        style: {
          marginTop: "15vh",
          borderRadius: "16px",
          overflow: "visible",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: "text.secondary",
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>

      <AddBankAccountForm
        initialData={initialData} // Pass initial data
        onClose={onClose}
        onSuccess={() => {
          onClose();
          onUserAdded();
        }}
      />
    </Dialog>
  );
};

export default AddBankAccountModal;
